package com.macrofocus.eflux.ui.svg

import js.string.asString
import web.svg.SVGElement

val SVGElement.dataName : String
    get() = if(hasAttribute("data-name")) getAttribute("data-name")!!.replace("_x5F_", "_") else id.asString()

fun SVGElement.callRecursive(action : (SVGElement) -> Unit ) {
    action(this)
    for(i in 0..this.childElementCount) {
        val child = this.children[i]
        if(child is SVGElement) {
            child.callRecursive(action)
        }
    }
}

fun List<SVGElement>.forEachRecursive(lamda : (SVGElement) -> Unit) {
    this.forEach { it.callRecursive( lamda) }
}
